import { generateId } from 'shared/entities/common/utils';

/**
 * Генерирует уникальный ключ для компании на основе ИНН
 * Формат: inn_uniqueId
 * @param inn - ИНН компании
 * @returns уникальный ключ
 */
export const generateCompanyKey = (inn: string): string => {
  const uniqueId = generateId();
  return `${inn}_${uniqueId}`;
};

/**
 * Извлекает ИНН из ключа компании
 * @param key - ключ компании в формате inn_uniqueId
 * @returns ИНН компании
 */
export const parseCompanyKey = (key: string): string => {
  // ИНН - это все до первого подчеркивания
  return key.split('_')[0];
};
